var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"review-video-thumbnail",on:{"click":function($event){$event.stopPropagation();return _vm.showPreviewModal.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.videoThumbnail,"alt":"Greeting video thumbnail"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }